import styled from "styled-components";
import AtendenteVipImg from "./img/vipnpc.gif"
import RestauracaoIcon from "./img/santuario.png"
import CardIcon from "./img/carta.gif"
import NeuralizerIcon from "./img/neuralizador.gif"
import EmperiumIcon from "./img/emperium.gif"
import BlessIcon from "./img/bencao.png"
import AgilityIcon from "./img/aumenagi.png"
import AngelusIcon from "./img/angelus.png"
import GloriaIcon from "./img/gloria.png"
import ImpositioIcon from "./img/impomanus.png"
import VipIconImg from "../meucadastro/img/goldstar.png"
import { TipMouseOverEvent, TipMouseOutEvent } from "../../../../Tooltip/Tooltip";


function ServicosDisponiveis(){
    return(
        <MasterServicos>

            <TitleMaster>
                <ColumItemHeaderIcon iconImg={VipIconImg}/>
                <TitleFont>Atendente VIP</TitleFont>
            </TitleMaster>

            <TitleContainer>
                    <Span>
                        Durante seu acesso <b>VIP</b> você poderá aproveitar os serviços disponíveis nas <b>Assistentes VIP</b>.<br/> 
                        Elas se encontram espalhadas nas cidades do jogo.<br/>
                        Confira os serviços que estão disponíveis:
                    </Span>
            </TitleContainer>

            <Session1>

                <AtendenteVip
                onMouseOver={(event) => 
                TipMouseOverEvent(event, "NPC Exclusivo Acesso VIP.", "rgb(14, 134, 30)")}
                onMouseLeave={() => TipMouseOutEvent()}/>

                <ColumnA>
                    <ColumnItem onMouseOver={(event) => TipMouseOverEvent(event, "<b>100% do HP & SP</b> do  personagem .", "rgb(0, 0, 0)")} onMouseLeave={() => TipMouseOutEvent()}><ServiceIcon img={RestauracaoIcon} width={"20px"} height={"20px"}/> Restauração de Energia
                    </ColumnItem>

                    <ColumnItem onMouseOver={(event) => TipMouseOverEvent(event, "<b>Reseta pontos</b> de atributos e habilidades.", "rgb(0, 0, 0)")} onMouseLeave={() => TipMouseOutEvent()}><ServiceIcon img={NeuralizerIcon} width={"20px"} height={"20px"}/> Resetadora de Pontos </ColumnItem>

                    <ColumnItem onMouseOver={(event) => TipMouseOverEvent(event, "Concede <b>Benção em nivel 10</b> por 5 minutos.", "rgb(0, 0, 0)")} onMouseLeave={() => TipMouseOutEvent()}><ServiceIcon img={BlessIcon} width={"30px"} height={"30px"}/> Abençoar Jornada </ColumnItem>
                
                    <ColumnItem onMouseOver={(event) => TipMouseOverEvent(event, "Extrai cartas de equipamentos.", "rgb(0, 0, 0)")} onMouseLeave={() => TipMouseOutEvent()}><ServiceIcon img={CardIcon} width={"30px"} height={"25px"}/>  Remover Cartas</ColumnItem>
                    <ColumnItem onMouseOver={(event) => TipMouseOverEvent(event, "Envio diretamente para  WoE 1.0 e WoE 2.0.", "rgb(0, 0, 0)")} onMouseLeave={() => TipMouseOutEvent()}><ServiceIcon img={EmperiumIcon} width={"25px"} height={"23px"}/>  WoE Teletransporte</ColumnItem>
                    
                    <ColumnItem onMouseOver={(event) => TipMouseOverEvent(event, "Concede <b>Aumentar Agilidade em nivel 10</b> por 5 minutos.", "rgb(0, 0, 0)")} onMouseLeave={() => TipMouseOutEvent()}><ServiceIcon img={AgilityIcon} width={"30px"} height={"30px"}/>  Aumentar Agilidade</ColumnItem>  
               
                    <ColumnItem onMouseOver={(event) => TipMouseOverEvent(event, "Concede <b>Angelus em nivel 10</b> por 10 minutos.", "rgb(0, 0, 0)")} onMouseLeave={() => TipMouseOutEvent()}><ServiceIcon img={AngelusIcon} width={"30px"} height={"30px"}/> Sino da Proteção </ColumnItem>

                    <ColumnItem onMouseOver={(event) => TipMouseOverEvent(event, "Concede <b>Impositio Manus em nivel 5</b> por 2 min e 30 segundos.", "rgb(0, 0, 0)")} onMouseLeave={() => TipMouseOutEvent()}><ServiceIcon img={ImpositioIcon} width={"30px"} height={"30px"}/> Impositio Manus</ColumnItem>

                    <ColumnItem onMouseOver={(event) => TipMouseOverEvent(event, "Concede <b>Gloria em nivel 5</b> por 2 min e 30 segundos.", "rgb(0, 0, 0)")} onMouseLeave={() => TipMouseOutEvent()}><ServiceIcon img={GloriaIcon} width={"30px"} height={"27px"}/>  Batalha Gloriosa</ColumnItem>
                </ColumnA>

            </Session1>

            
        </MasterServicos>

    );
};


const MasterServicos = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    //border: solid;
    width: 100%;
    margin-bottom: 20px;

    @media(max-width: 1000px) {
      width: 90vw;
    }
`

const TitleMaster = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    width: 100%;
    border-radius: 5px;
    transition: .3s ease-in-out;
    margin: 10px 0;
    //border: solid;
    background-color: rgba(0,0,0,.7);
    color: white;
    font-size: 15pt;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    @media(max-width: 1000px) {
      width: 90vw;
      padding: 0 0px;
    }

`

const TitleFont = styled.span`
    font-size: 24pt;
    font-weight: bold;
    margin: 25px 0;

    @media(max-width: 1000px) {
      font-size: 20pt
    }

`

const ColumItemHeaderIcon = styled.div`
    background-image: url(${props => props.iconImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 45px;
    height: 45px;
    margin: 0 55px;
    //border: solid;

     @media(max-width: 1000px) {
        width: 35px;
        height: 35px;
        margin: 0 20px;
    }
    
`

const TitleContainer = styled.span`
    display: flex;
    width: 100%;
    border-radius: 5px;
    padding: 10px 0px;
    background-color: rgba(0,0,0,.7);
    color: white;

    @media(max-width: 1000px) {
        scale: 1.0;
        width: 100%;
        align-items: center;
        //border: solid;
        text-align: center;
        margin-bottom: 20px;
    }
`


const Span = styled.span`
    font-size: 14pt;
    margin: 10px 40px;
`

const Session1 = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    //border: solid;
    border-radius: 5px;
    width: 100%;
    padding: 20px 0px;

    @media(max-width: 1000px) {
      width: 90%;
      flex-direction: column;
      padding: 0px 0px;
    }
`



const AtendenteVip = styled.div`
    background-image: url(${AtendenteVipImg});
    background-repeat: no-repeat;
    background-size: cover;
    backrgound-position: center center;
    width: 60px;
    height: 130px;
    //border: solid;
    //background-color: white;
    border-radius: 5px;
    margin-right: 20px;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

     @media(max-width: 1000px) {
      scale: .9;
      margin-right: 0px;
      align-items: center;
      //border: solid;
    }
`



const Session2 = styled.div`
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    width: 100%;
    align-items: center;
    //border: solid;

    @media(max-width: 1000px) {
      width: 90vw;
      align-items: center;
    }
    
`

const ColumnA = styled.div`
    display: flex;
    align-items: start;
    justify-content: start;
    flex-wrap: wrap;
    width: 780px;
    padding: 10px 0px;
    //border: solid;
    border-radius: 5px;
    background-color: rgba(0,0,0,.7);

    @media(max-width: 1000px) {
      flex-direction: column;
      width: 90vw;
      align-items: center;
      padding: 0px 0px;
    }
`

const ColumnItem = styled.span`
    display: flex;
    align-items: center;
    justify-content: start;
    width: 230px;
    margin: 5px 10px;
    //box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.9);
    border-radius: 5px;
    background-color: rgba(0,0,0,.7);
    color: white;
    padding: 15px 5px;
    border-radius: 5px;
    transition: .3s;
    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

    &:hover {
    transform: translate(-5px,-5px);
    scale: 1.1;
    }

    @media(max-width: 1000px) {
      width: 90%;
      margin: 5px 0;
    }

`

const ServiceIcon = styled.div`
    background-image: url(${props => props.img});
    background-repeat: no-repeat;
    background-size: cover;
    backrgound-position: center center;
    width: 20px;
    height: 20px;
    margin: 0 10px ;
`



export default ServicosDisponiveis;